import reducer from './programDays';
import { actionCreators, ProgramDaysActionType } from './programDays.actionCreators';
import * as actionTypes from './programDays.actionTypes';

export * from './programDays';
export * from './programDays.selectors';
export type ActionType = ProgramDaysActionType;
export { actionTypes, actionCreators };
export default reducer;
